// Copyright (c) 2021 Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import {
  ProductCard,
  DisplayAmount
} from '../'

export class InvestmentProductCard extends React.PureComponent {
  static propTypes = {
    investmentId: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    instrumentInternalName: PropTypes.string.isRequired,
    investedBalance: PropTypes.number.isRequired,
    processingBalance: PropTypes.number.isRequired,
    clientContribution: PropTypes.number.isRequired,
    employerContribution: PropTypes.number.isRequired,
    detailLink: PropTypes.string,
    onDetailLinkClick: PropTypes.func,
    detailView: PropTypes.bool,
    onClick: PropTypes.func,
    backgroundColour: PropTypes.string,
    footerBackgroundColour: PropTypes.string,
    inverseColours: PropTypes.bool,
    className: PropTypes.string
  }

  static defaultProps = {
    className: ''
  }

  render() {
    const { investmentId, productName, instrumentInternalName, investedBalance, processingBalance, clientContribution, employerContribution, detailLink, onDetailLinkClick, detailView, onClick, backgroundColour, footerBackgroundColour, inverseColours, inverseFooterColours, className } = this.props

    return (
      <ProductCard
        title={instrumentInternalName}
        subtitle={productName}
        product={productName}
        secondaryDetails={{
          'Own contribution': <DisplayAmount amountString={clientContribution} />,
          'Investment balance': <DisplayAmount amountString={investedBalance} />,
          'Employer contribution': <DisplayAmount amountString={employerContribution} />,
          'Investment in progress': <DisplayAmount amountString={processingBalance} />,
        }}
        footerText='Detail and history'
        footerLink={detailLink}
        onFooterLinkClick={() => onDetailLinkClick(investmentId)}
        hideFooter={detailView}
        onClick={onClick}
        backgroundColour={backgroundColour}
        footerBackgroundColour={footerBackgroundColour}
        inverseColours={inverseColours}
        inverseFooterColours={inverseFooterColours}
        className={`product-card ${className}`}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/investment-product-card/index.js